module.exports = __webpack_public_path__ + "img/PdSM.d0ae4e0b.svg";